import './Publications.css'
import parse from 'html-react-parser'

const Publications = ({ papers = [] }) => {
  // Guard
  if (!Array.isArray(papers) || papers.length === 0) {
    return null
  }

  // Group by year
  const groupedPapers = papers.reduce((acc, p) => {
    const year = String(p?.year ?? 'Unknown')
    if (!acc[year]) acc[year] = []
    acc[year].push(p)
    return acc
  }, {})

  // Sort years desc numerically when possible, "Unknown" last
  const sortedYears = Object.keys(groupedPapers).sort((a, b) => {
    const na = Number(a)
    const nb = Number(b)
    if (Number.isNaN(na) && Number.isNaN(nb)) return a.localeCompare(b)
    if (Number.isNaN(na)) return 1
    if (Number.isNaN(nb)) return -1
    return nb - na
  })

  return (
    <div className='about__details'>
      <section className='section publications' aria-labelledby='pubs-title'>
        <h2 id='pubs-title' className='section__title'>
          Publications
        </h2>

        {sortedYears.map((year) => (
          <div key={year} className='publication__year-group'>
            <h3 className='publication__year-heading'>
              <span className='publication__year-pill'>{year}</span>
            </h3>

            <ul className='publications__list'>
              {groupedPapers[year]
                // optional: sort each year alphabetically by title
                .slice()
                .sort((p1, p2) =>
                  (p1.title || '').localeCompare(p2.title || '')
                )
                .map((paper, idx) => {
                  const key = `${year}-${paper.title || idx}`
                  const hasConf = Boolean(
                    paper.conference && paper.conference.trim()
                  )
                  return (
                    <li key={key} className='publication__item'>
                      {paper.link ? (
                        <a
                          href={paper.link}
                          target='_blank'
                          rel='noopener noreferrer'
                          className='publication__title'
                          aria-label={`${paper.title} (opens in new tab)`}
                        >
                          {paper.title}
                        </a>
                      ) : (
                        <span className='publication__title publication__title--nolink'>
                          {paper.title}
                        </span>
                      )}

                      {paper.authors && (
                        <span className='publication__authors'>
                          {' — '}
                          {parse(paper.authors)}
                        </span>
                      )}

                      {hasConf && (
                        <span className='publication__conference'>
                          {' · '}
                          <cite>{paper.conference}</cite>
                        </span>
                      )}
                    </li>
                  )
                })}
            </ul>
          </div>
        ))}
      </section>
    </div>
  )
}

export default Publications
